import { Component, OnDestroy, OnInit } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { ActivatedRoute, Router } from "@angular/router";
import { Subscription } from "rxjs";
import { ApiService } from "src/app/providers/api.service";
import { SM_CONSTANTS } from "src/app/shared/constants/sm-constants";
import { YoutubeEmbedVideoComponent } from "../../../new-v2-component/youtube-embed-video/youtube-embed-video.component";
import { link } from "fs";
import { MatSnackBar } from "@angular/material/snack-bar";
import { NotificationService } from "src/app/services/notification.service";
import { CustomSnackbarComponent } from "src/app/shared/components/custom-snackbar/custom-snackbar.component";
import { AuthService } from "src/app/providers/auth.service";
import { InvoiceForReportComponent } from "src/app/shared/components/invoice-for-report/invoice-for-report.component";
import { InvoiceForReportOnlyComponent } from "src/app/shared/components/invoice-for-report-only/invoice-for-report-only.component";

@Component({
  selector: 'sm-unpaid-invoices',
  templateUrl: './unpaid-invoices.component.html',
  styleUrls: ['./unpaid-invoices.component.scss']
})
export class UnpaidInvoicesComponent implements OnInit, OnDestroy {
  repeatArray: any;
  todaysBookingData: any = [];
  toshowData: boolean = true;
  loader: boolean = false;
  _apisub: Subscription;
  unpaidInvoicesData:any = []
  constructor(
    private _apiservice: ApiService,
    private router: Router,
    private dialog: MatDialog,
    private _snackBar: MatSnackBar,
    private notificationService: NotificationService,
    private authService: AuthService,
    private route: ActivatedRoute
  ) {
    // this.listenForNewBookingUpdates();
    // this.listenForBookingStatusUpdates();
    // this.listenForMemberAttendance();
    // this.listenForBookingAssignmentUpdates();
    // this.listenForMemberBookingStatusUpdate();
    // this.listenForMemberBookingAssignmentUpdates();
    this._apisub = this._apiservice.apiResult.subscribe((resdata) => {
      if (
        resdata.responseType ===
        SM_CONSTANTS.RESULT_API_GET_LATEST_UNPAID_INVOICE_STATUS_FOR_DASHBOARD
      ) {
        this.unpaidInvoicesData = [];
        if (resdata.result) {
          resdata.result.forEach((element: any) => {
              this.unpaidInvoicesData.push(element)
          });
        }
        if (this.unpaidInvoicesData.length < 4) {
          this.repeatArray = new Array(4 - this.unpaidInvoicesData.length);
        }
        this.loader = false;
      }



      if (
        resdata.responseType === SM_CONSTANTS.RESULT_API_ADD_EDIT_PAYMENT_RECORD
      ) {
            this._apiservice.getLatestUnpaidInvoiceStatusForDashboard("1", "4");

      }
      if (
        resdata.responseType ===
        SM_CONSTANTS.RESULT_API_ADD_EDIT_INTERNATIONAL_INVOICE_PAYMENT_RECORD
      ) {
            this._apiservice.getLatestUnpaidInvoiceStatusForDashboard("1", "4");

      }
      if (
        resdata.responseType === SM_CONSTANTS.RESULT_API_RECORD_FITNESS_INVOICE
      ) {
            this._apiservice.getLatestUnpaidInvoiceStatusForDashboard("1", "4");

      }
      if (
        resdata.responseType ===
        SM_CONSTANTS.RESULT_API_ADD_EDIT_FITNESS_INTERNATIONAL_INVOICE_PAYMENT_RECORD
      ) {
            this._apiservice.getLatestUnpaidInvoiceStatusForDashboard("1", "4");

      }
      if (
        resdata.responseType === SM_CONSTANTS.RESULT_API_DELETE_ENTITY_INVOICE
      ) {
           this._apiservice.getLatestUnpaidInvoiceStatusForDashboard("1", "4");

      }
      if (
        resdata.responseType ===
        SM_CONSTANTS.RESULT_API_DELETE_INTERNATIONAL_INVOICE_DETAILS
      ) {
            this._apiservice.getLatestUnpaidInvoiceStatusForDashboard("1", "4");

      }

    });
  }

  ngOnInit(): void {
    this.loader = true;
    this._apiservice.getLatestUnpaidInvoiceStatusForDashboard("1", "4");
  }
  openAllTodaysBookings() {
    this.router.navigate(["all-today-bookings"]);
  }
  openAllUnpaidInvoices() {
    this.router.navigate(["all-unpaid-invoices"]);
  }

  openvideo() {
    this.dialog.open(YoutubeEmbedVideoComponent, {
      width: "1000px",
      disableClose: true,
      data: {
        link: "",
        title: "Today's bookings",
      },
    });
  }

  private newbookingsubscription: Subscription = new Subscription();
  listenForNewBookingUpdates() {
    this.newbookingsubscription = this.notificationService
      .getNotificationByType("newBooking")
      .subscribe((payload) => {
        if (true) {
          console.log("New notification received:", payload);
          payload.data.misc =
            typeof payload.data.misc == "string"
              ? JSON.parse(payload.data.misc)
              : payload.data.misc;
          if (true) {
            //check and update for todays bookings only

            this._apiservice.getTodaysBookingsForDashboard("4", "1");

            // const snackBarRef = this._snackBar.openFromComponent(CustomSnackbarComponent, {
            //   duration: 5000, // Adjust duration as needed
            //   horizontalPosition: 'center',
            //   verticalPosition: 'top',
            //   data: { title, message},
            //   panelClass:'custom-class1'
            // });

            // snackBarRef.afterDismissed().subscribe(() => {
            //   console.log('Snackbar dismissed');
            // });

            // snackBarRef.onAction().subscribe(() => {
            //   console.log('Snackbar action triggered');
            // });
          }
        }
      });
  }
  private memberbookingstatuschangedsubscription: Subscription =
    new Subscription();
  listenForMemberBookingStatusUpdate() {
    this.memberbookingstatuschangedsubscription = this.notificationService
      .getNotificationByType("memberBookingStatusUpdated")
      .subscribe((payload) => {
        if (true) {
          console.log("New notification received:", payload);
          payload.data.misc =
            typeof payload.data.misc == "string"
              ? JSON.parse(payload.data.misc)
              : payload.data.misc;
          if (true) {
            //check and update for todays bookings only

            this._apiservice.getTodaysBookingsForDashboard("4", "1");

            // const snackBarRef = this._snackBar.openFromComponent(CustomSnackbarComponent, {
            //   duration: 5000, // Adjust duration as needed
            //   horizontalPosition: 'center',
            //   verticalPosition: 'top',
            //   data: { title, message},
            //   panelClass:'custom-class1'
            // });

            // snackBarRef.afterDismissed().subscribe(() => {
            //   console.log('Snackbar dismissed');
            // });

            // snackBarRef.onAction().subscribe(() => {
            //   console.log('Snackbar action triggered');
            // });
          }
        }
      });
  }
  private memberBookingAssignmentsubscription: Subscription =
    new Subscription();
  listenForMemberBookingAssignmentUpdates() {
    this.memberBookingAssignmentsubscription = this.notificationService
      .getNotificationByType("onMemberAssign")
      .subscribe((payload) => {
        if (true) {
          console.log("New notification received:", payload);
          payload.data.misc =
            typeof payload.data.misc == "string"
              ? JSON.parse(payload.data.misc)
              : payload.data.misc;
          if (true) {
            //check and update for todays bookings only

            this._apiservice.getTodaysBookingsForDashboard("4", "1");

            // const snackBarRef = this._snackBar.openFromComponent(CustomSnackbarComponent, {
            //   duration: 5000, // Adjust duration as needed
            //   horizontalPosition: 'center',
            //   verticalPosition: 'top',
            //   data: { title, message},
            //   panelClass:'custom-class1'
            // });

            // snackBarRef.afterDismissed().subscribe(() => {
            //   console.log('Snackbar dismissed');
            // });

            // snackBarRef.onAction().subscribe(() => {
            //   console.log('Snackbar action triggered');
            // });
          }
        }
      });
  }

  private bookingStatusUpdatedsubscription: Subscription = new Subscription();
  listenForBookingStatusUpdates() {
    this.bookingStatusUpdatedsubscription = this.notificationService
      .getNotificationByType("bookingStatusUpdated")
      .subscribe((payload) => {
        if (true) {
          console.log("New notification received:", payload);
          payload.data.misc =
            typeof payload.data.misc == "string"
              ? JSON.parse(payload.data.misc)
              : payload.data.misc;
          if (true) {
            //check and update for todays bookings only

            this._apiservice.getTodaysBookingsForDashboard("4", "1");
          }
        }
      });
  }
  private bookingAssignmentsubscription: Subscription = new Subscription();
  listenForBookingAssignmentUpdates() {
    this.bookingAssignmentsubscription = this.notificationService
      .getNotificationByType("onCustomerAssign")
      .subscribe((payload) => {
        if (true) {
          console.log("New notification received:", payload);
          payload.data.misc =
            typeof payload.data.misc == "string"
              ? JSON.parse(payload.data.misc)
              : payload.data.misc;
          if (true) {
            //check and update for todays bookings only

            this._apiservice.getTodaysBookingsForDashboard("4", "1");
          }
        }
      });
  }

  private memberattendancesubscription: Subscription = new Subscription();
  listenForMemberAttendance() {
    this.memberattendancesubscription = this.notificationService
      .getNotificationByType("onMemberAttendance")
      .subscribe((payload) => {
        if (true) {
          console.log("New notification received:", payload);
          payload.data.misc =
            typeof payload.data.misc == "string"
              ? JSON.parse(payload.data.misc)
              : payload.data.misc;
          if (true) {
            //check and update for todays bookings only

            this._apiservice.getTodaysBookingsForDashboard("4", "1");
          }
        }
      });
  }

  ngOnDestroy(): void {
    this._apisub.unsubscribe();
    if (this.newbookingsubscription) {
      this.newbookingsubscription.unsubscribe();
    }
    if (this.bookingStatusUpdatedsubscription) {
      this.bookingStatusUpdatedsubscription.unsubscribe();
    }
    if (this.memberattendancesubscription) {
      this.memberattendancesubscription.unsubscribe();
    }
    if (this.memberbookingstatuschangedsubscription) {
      this.memberbookingstatuschangedsubscription.unsubscribe();
    }
    if (this.bookingAssignmentsubscription) {
      this.bookingAssignmentsubscription.unsubscribe();
    }
    if (this.memberBookingAssignmentsubscription) {
      this.memberBookingAssignmentsubscription.unsubscribe();
    }
  }

  bookingDetails(item: any) {
    // this._modelRef.open(CustomerBookingDetailsComponent, {
    //   width: '700px',
    //   data: {
    //     title: 'Bookings Details',
    //     ref: this._modelRef,
    //     data: item.booking_hash,
    //   },
    // });
    this.authService.setUserRole(item.is_owner == 1 ? "owner" : "employee");
    localStorage.setItem(
      SM_CONSTANTS.OWNER_EMPLOYEE_HASH_ID,
      item.employee_hash_id
    );
    localStorage.setItem(
      SM_CONSTANTS.CURRENT_ENTITY_PUBLIC_PROFILE_HASH_ID,
      item.entity_public_hash_id
    );

    if (item.data_type == 1) {
      this.router.navigate(["booking-details"], {
        relativeTo: this.route,
        queryParams: {
          bookingHash: item.booking_hash,
          entityHash: item.business_hash,
          eph: item.entity_public_hash_id,
        },
      });
    } else if (item.data_type == 2) {
      this.router.navigate(["membership-booking-details"], {
        relativeTo: this.route,
        queryParamsHandling: "merge",
        queryParams: {
          memberHash: item.member_hash,
          isf: "0",
          entityHash: item.business_hash,
          bd: item.booking_date,
        },
      });
    } else if (item.data_type == 3) {
      this.router.navigate(["query-details"], {
        relativeTo: this.route,
        queryParamsHandling: "merge",
        queryParams: {
          queryHash: item.booking_hash,
          entityHash: item.business_hash,
          eph: item.entity_public_hash_id,
        },
      });
    }
  }

  formatTimeforquery(time: string): string {
    const [hour, minute] = time.split(":").map(Number);
    const period = hour >= 12 ? "PM" : "AM";
    const adjustedHour = hour % 12 || 12; // Convert 0 or 12 to 12 for AM/PM time
    return `${adjustedHour}:${minute.toString().padStart(2, "0")} ${period}`;
  }
  formatSchedule(schedule: any[]): string {
    return schedule
      .map((item) => {
        const weekday = this.getWeekdayString(item.weekday);
        const startTime = this.formatTimeforquery(item.start_time);
        const endTime = this.formatTimeforquery(item.end_time);
        return `${weekday}: ${startTime} - ${endTime}`;
      })
      .join(", ");
  }

  getWeekdayString(weekday: number): string {
    const weekdays = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
    return weekdays[weekday - 1]; // Adjusting because weekday starts from 1
  }

    openInvoice(item: any) {
      let isEntityForeign = item.currency == "INR" ? "0" : "1";
      localStorage.setItem(SM_CONSTANTS.IS_ENTITY_FOREIGN,isEntityForeign)
      if (item.bookingHashId) {
        this.dialog.open(InvoiceForReportComponent, {
          width: "510px",
          data: {
            title: "Invoice",
            ref: this.dialog,
            data: item.bookingHashId,
          },
        });
      } else {
        this.dialog.open(InvoiceForReportOnlyComponent, {
          width: "510px",
          data: {
            title: "Invoice",
            ref: this.dialog,
            data: item.hash_id,
            entityHash: item.entityHash,
          },
        });
      }
    }
}
